class Language {
  constructor() {
    this.singular = {
      jobs: 'job',
      reviews: 'review',
      companies: 'company',
      'opted-in-companies': 'company',
      'opted-out-companies': 'company',
      'company-opt-ins': 'company',
    };

    this.plural = {
      jobs: 'jobs',
      reviews: 'reviews',
      companies: 'companies',
      'opted-in-companies': 'companies',
      'opted-out-companies': 'companies',
      'company-opt-ins': 'companies',
    };
  }

  convertSinglular(key) {
    return this.singular[key];
  }
}

const language = new Language();

export default {

  alert: {
    added: {
      companies: (company) => `You’ve now saved ${company}. If you’d like to hear from ${company} first hand, you can change your settings in your dashboard`,
      registerInterest: 'You have successfully registered your interest! This job has been added to your saved items.',
    },
    already: {
      jobs: 'Job already saved!',
      companies: 'Company already saved!',
    },
    deleted: {
      jobs: 'Job removed from your saved items',
      companies: 'You are no longer following this company',
      reviews: 'Review removed from your saved items',
      'opted-in-companies': 'You are no longer opted in to this company',
    },
    toggleAll: {
      on: (type) => `You will now receive email reminders for your saved ${type}`,
      off: (type) => `You will no longer receive email reminders for your saved ${type}`,
      shareData: {
        off: 'Your data will no longer be shared with saved companies',
        on: 'Your data will be shared with saved companies',
      },
    },
    toggle: {
      on: (type) => `You will now receive email reminders for this saved ${language.convertSinglular(type)}`,
      off: (type) => `You will no longer receive email reminders for this saved ${language.convertSinglular(type)}`,
      shareData: {
        on: 'Your data will be shared with this company',
        off: 'Your data will no longer be shared with this company',
      },
    },
    error: {
      heading: 'Whoops, something went wrong!',
      message: 'Please try again.',
    },
  },
  savedSearch: {
    create: 'Saved search successfully created',
    update: 'Saved search successfully updated',
    updateError: 'You’ve already saved a search with this criteria',
    delete: 'Saved search successfully deleted',
    unsubscribe: 'You have successfully unsubscribed from all saved search alerts',
    validationError: 'There are validation errors on the form',
    searchError: 'There was an error running your search',
  },
  diversityQuestions: {
    explainer: `Some of our employer partners run initiatives to help widen access into their profession from under-represented groups.
    We ask you the following questions in order to send you relevant information
    about initiatives that you might be interested in.`,
    privacyPolicy: 'We will NOT share your data with third parties.',
  },
};
